/**
 * Created by vladislav on 23/03/2023
 */

const SnapScrollView = cleverapps.UI.ScrollView.extend({ 
    ctor: function (items, options) {
        options.direction = options.direction === cleverapps.UI.ScrollView.DIR_VERTICAL
            ? cleverapps.UI.VERTICAL
            : cleverapps.UI.HORIZONTAL;

        this.page = options.page || 0;

        this.items = items;
        this.onChangePage = options.onChangePage;

        const content = new cleverapps.Layout(items, options);

        if (this.getPagesAmount() < 2) {
            this.touchScrollDisabled = true;
        }

        this._super(content, options);

        this.pageSize = options.pageSize || {
            width: items[1].width * items[1].scale,
            height: items[1].height * items[1].scale
        };

        const width = options.width || this.pageSize.width * (options.pagesCount || 1);
        const height = options.height || this.pageSize.height * 1.7;

        this.setContentSize(width, height);

        this.scrollTo(this.items[this.page]);
    },

    getPagesAmount: function () {
        return this.items.length;
    }
});